import { memo } from 'react';

import { Heading, Text } from '@sravni/react-design-system/lib/Typography';

import type { IClientMicrocredit } from '@src/@types/clienttypes';
import { RedirectReviewButton } from 'src/components/details/components/RedirectReviewButton';

import styles from './styles.module.scss';

type Props = {
  organizationName: string;
  reviewLink: string;
  name: string;
  advertising: IClientMicrocredit['advertising'];
};

export const AddReview = memo(({ organizationName, reviewLink, name, advertising }: Props) => {
  const text = `Расскажите о своем опыте получения займа в ${organizationName}`;

  return (
    <div className={styles.wrapper}>
      <Heading level={4}>Оставьте отзыв</Heading>
      <Text size={14} className="h-mt-8 h-mb-16">
        {text}
      </Text>
      <RedirectReviewButton
        link={reviewLink}
        text="Написать отзыв"
        name={name}
        organizationName={organizationName}
        advertising={advertising}
      />
    </div>
  );
});
